const keys = {
  //googleMapsApi: 'AIzaSyC6-mNKrIxoPspGB7S33hMgLsLXQslTGT0'
  googleMapsApi: 'AIzaSyAEra68A-iNDUg001_1gnhMVrWA3JjKBKQ'
};

export default keys;
